import {
  LOAD_PROJECTS_LIST,
  SET_PROJECTS_LIST,
  LOAD_PROJECT_DETAILS,
  LOAD_PUBLIC_PROJECT_DETAILS,
  LOAD_PUBLIC_PROJECT_RECIPIENTS,
  SET_PROJECT_DETAILS,
  SET_PUBLIC_RECIPIENTS_PAGINATION_COUNT,
  SET_PUBLIC_PROJECT_RECIPIENTS,
  SET_PUBLIC_PROJECT_DETAILS,
  LOAD_PROJECT_LINK_INFO,
  SET_PROJECT_INFO,
  SET_RECIPIENT_CUSTOM_SIZES,
  SETTING_PROJECT_RECIPIENT_INFO,
  PROJECT_EMAIL_ALREADY_IN_USE,
  UPDATING_ALLOWED_DOMAIN,
  UPDATING_RECIPIENT,
  UPDATING_PUBLIC_RECIPIENT,
  DELETING_RECIPIENT,
  FINALIZING_ORDER,
  FINALIZING_PUBLIC_ORDER,
  SEARCHING_RECIPIENT,
  SET_RECIPIENT_INFO,
  UPDATE_RECIPIENT_INFO,
  SET_RECIPIENT_VERIFICATION_STATUS,
  ENABLE_ADDRESS_COLLECTION,
  DISABLE_ADDRESS_COLLECTION,
  SET_COLLECTION_LINK_STATE,
  VERIFICATION_EMAIL_STATUS
} from '@/state/mutationTypes'

export default {
  [SET_COLLECTION_LINK_STATE](state, payload) {
    state.projectDetails.enableCollectionLink = payload
  },
  [ENABLE_ADDRESS_COLLECTION](state, payload) {
    state.toggleAddressCollection = payload
  },
  [DISABLE_ADDRESS_COLLECTION](state, payload) {
    state.toggleAddressCollection = payload
  },
  [LOAD_PROJECTS_LIST](state, payload) {
    state.projectsListLoading = payload
  },
  [SET_PROJECTS_LIST](state, payload) {
    state.projectsList = [...payload]
  },
  [LOAD_PROJECT_DETAILS](state, payload) {
    state.loadingProjectDetails = payload
  },
  [LOAD_PUBLIC_PROJECT_DETAILS](state, payload) {
    state.loadingPublicProjectDetails = payload
  },
  [LOAD_PUBLIC_PROJECT_RECIPIENTS](state, payload) {
    state.loadingRecipients = payload
  },
  [SET_PROJECT_DETAILS](state, payload) {
    state.projectDetails = { ...payload }
  },
  [SET_PUBLIC_PROJECT_DETAILS](state, payload) {
    state.publicProjectDetails = { ...payload }
  },
  [SET_PUBLIC_RECIPIENTS_PAGINATION_COUNT](state, payload) {
    state.totalCount = payload
  },
  [SET_PUBLIC_PROJECT_RECIPIENTS](state, payload) {
    state.publicRecipients = payload
  },
  [LOAD_PROJECT_LINK_INFO](state, payload) {
    state.loadingProjectLinkInfo = payload
  },
  [SET_PROJECT_INFO](state, payload) {
    state.projectInfo = { ...payload }
  },
  [VERIFICATION_EMAIL_STATUS](state, payload) {
    state.verificationEmailSent = payload
  },
  [SET_RECIPIENT_CUSTOM_SIZES](state, payload) {
    let actualIndex = state.recipientInfo.apparelSize.findIndex(
      apparel => apparel.name === payload.name
    )
    if (actualIndex >= 0) {
      state.recipientInfo.apparelSize[actualIndex] = {
        name: payload.name,
        option: payload.option
      }
    } else {
      state.recipientInfo.apparelSize.splice(payload.index, 1, {
        name: payload.name,
        option: payload.option
      })
    }
  },
  [SET_RECIPIENT_INFO](state) {
    const defaultData = {
      name: '',
      email: '',
      phone: '',
      addressOne: '',
      addressTwo: '',
      city: '',
      country: 'US',
      state: '',
      zipcode: '',
      apparelSize: []
    }
    state.recipientInfo = defaultData
  },
  [UPDATE_RECIPIENT_INFO](state, payload) {
    state.recipientInfo = { ...state.recipientInfo, ...payload }
  },
  [SET_RECIPIENT_VERIFICATION_STATUS](state, payload) {
    state.projectRecipientVerified = payload
  },
  [SETTING_PROJECT_RECIPIENT_INFO](state, payload) {
    state.settingProjectRecipientInfo = payload
  },
  [PROJECT_EMAIL_ALREADY_IN_USE](state, payload) {
    state.emailInUse = payload
  },
  [UPDATING_ALLOWED_DOMAIN](state, payload) {
    state.updatingAllowedDomains = payload
  },
  [UPDATING_RECIPIENT](state, payload) {
    state.updatingRecipientInfo = payload
  },
  [UPDATING_PUBLIC_RECIPIENT](state, payload) {
    state.updatingPublicRecipientInfo = payload
  },
  [DELETING_RECIPIENT](state, payload) {
    state.deletingRecipient = payload
  },
  [FINALIZING_ORDER](state, payload) {
    state.finalizingOrder = payload
  },
  [FINALIZING_PUBLIC_ORDER](state, payload) {
    state.finalizingPublicOrder = payload
  },
  [SEARCHING_RECIPIENT](state, payload) {
    state.searchingRecipient = payload
  }
}
